import { persistReducer, persistStore } from "redux-persist";
import sagaMiddleware, { setupMiddleware } from "./middleware";

import { AnyAction, configureStore } from "@reduxjs/toolkit";

import { persistConfig } from "./options";
import rootReducer from "./reducers";

export type RootState = ReturnType<typeof rootReducer>;
const persistedReducer = persistReducer<RootState, AnyAction>(
  persistConfig,
  rootReducer
);

const store = configureStore({
  reducer: persistedReducer,
  middleware: (getDefaultMiddleware) =>
    getDefaultMiddleware({
      thunk: false,
      serializableCheck: false,
    }).concat(sagaMiddleware),
  // devTools: process.env.NODE_ENV !== "production",
});

setupMiddleware();

let persistor = persistStore(store);

export { store, persistor };
